import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_PICWORD } from './router';

export default registerRouteForModule(router);

menuRegistry.registerMenu([
    {
        parent: 'Puzzle',
        key: 'Pix2Word',
        name: 'Pix2Word',
        icon: 'fas fa-spell-check'
    },
    {
        parent: 'Puzzle.Pix2Word',
        key: 'Map',
        name: 'Map',
        icon: 'fas fa-map',
        route: { name: ROUTE_NAME_PICWORD.MAP.INDEX }
    },
    {
        parent: 'Puzzle.Pix2Word',
        key: 'Pet',
        name: 'Pet',
        icon: 'fas fa-cat',
        route: { name: ROUTE_NAME_PICWORD.PET.INDEX }
    },
    {
        parent: 'Puzzle.Pix2Word',
        key: 'Setting',
        name: 'Setting',
        icon: 'fas fa-cog',
        route: { name: ROUTE_NAME_PICWORD.SETTING }
    }
]);
